export default __webpack_public_path__ + "static/media/mum_thumb.e283eb87.png";